import React from 'react';
import PageNotFoundContainer from '@src/containers/PageNotFound';

const PageNotFound = () => <PageNotFoundContainer />;

export default PageNotFound;
